import React, { useCallback } from 'react';
import { Button } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import type { FJ751 } from '../../../services/pwj220Api';

interface Props {
  details: Partial<FJ751>[];
  isEditing: boolean;
  onAdd: () => void;
  onDelete: (idx: number) => void;
  onChange: (idx: number, field: keyof FJ751, value: any) => void;
}

const WashLabelDetail: React.FC<Props> = React.memo(
  ({ details, isEditing, onAdd, onDelete, onChange }) => {
    const handleChange = useCallback(
      (idx: number, field: keyof FJ751, value: any) => {
        onChange(idx, field, value);
      },
      [onChange]
    );

    return (
      <div className="detail-section">
        <div className="detail-header">
          <span>洗標明細</span>
          {isEditing && (
            <Button
              type="primary"
              size="small"
              icon={<PlusOutlined />}
              onClick={onAdd}
            >
              新增洗標
            </Button>
          )}
        </div>
        <table className="detail-table">
          <thead>
            <tr>
              <th data-contract-field="fj751_02">#</th>
              <th data-contract-field="fj751_11">洗標圖示代碼</th>
              <th data-contract-field="fj751_12">洗標說明</th>
              {isEditing && <th data-acceptance-non-field>操作</th>}
            </tr>
          </thead>
          <tbody>
            {details.length === 0 && (
              <tr>
                <td colSpan={isEditing ? 4 : 3} style={{ textAlign: 'center', color: '#999' }}>
                  尚無明細
                </td>
              </tr>
            )}
            {details.map((row, idx) => (
              <tr key={idx}>
                <td data-contract-field="fj751_02">{idx + 1}</td>
                <td>
                  <input
                    data-contract-field="fj751_11"
                    value={row.fj751_11 ?? ''}
                    onChange={e => handleChange(idx, 'fj751_11', e.target.value)}
                    disabled={!isEditing}
                    className="detail-input"
                  />
                </td>
                <td>
                  <input
                    data-contract-field="fj751_12"
                    value={row.fj751_12 ?? ''}
                    onChange={e => handleChange(idx, 'fj751_12', e.target.value)}
                    disabled={!isEditing}
                    className="detail-input wide"
                  />
                </td>
                {isEditing && (
                  <td>
                    <Button
                      danger
                      size="small"
                      icon={<DeleteOutlined />}
                      onClick={() => onDelete(idx)}
                    />
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
);

export default WashLabelDetail;
